import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  MarkGrantAsUnpaidInput,
  MarkGrantAsUnpaidMutation as MarkGrantAsUnpaidMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const MarkGrantAsUnpaidMutation = graphql(`
  mutation MarkGrantAsUnpaid($input: MarkGrantAsUnpaidInput!) {
    markGrantAsUnpaid(input: $input) {
      id
      paidAt
    }
  }
`);

const useMarkGrantAsUnpaid = (args: {
  projectId: string;
  options?: UseMutationOptions<
    MarkGrantAsUnpaidMutationResult,
    Error,
    MarkGrantAsUnpaidInput
  >;
}) => {
  const { projectId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation<
    MarkGrantAsUnpaidMutationResult,
    Error,
    MarkGrantAsUnpaidInput
  >({
    mutationFn: (input) =>
      gqlClient.request(MarkGrantAsUnpaidMutation, { input }),
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: projectKeys.project(projectId),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useMarkGrantAsUnpaid;
